import React from 'react';
import { SvgRenderResult } from '../utils/ganttSvgGenerator';
import { Eye, Layers } from 'lucide-react';

interface GanttPreviewProps {
  renderResult: SvgRenderResult;
  taskCount: number;
}

export const GanttPreview: React.FC<GanttPreviewProps> = ({
  renderResult,
  taskCount,
}) => {
  return (
    <div className="preview-container">
      <div className="preview-header">
        <div className="preview-title">
          <Eye size={15} />
          <span>Live Presentation Preview</span>
        </div>
        <div className="preview-meta">
          <span className="meta-tag">
            <Layers size={13} /> {taskCount} Tasks
          </span>
          <span className="meta-tag">
            {renderResult.width} &times; {renderResult.height}px
          </span>
        </div>
      </div>

      <div className="preview-canvas-wrapper">
        <div
          className="preview-svg-render"
          dangerouslySetInnerHTML={{ __html: renderResult.svgString }}
        />
      </div>
    </div>
  );
};
